import { DeliveryType } from '@libs/core';

export type Quantity = {
    label: string;
    value: string;
};

const MAX_DISPLAY_QTY = 500;

const getAvailableQuantities = (
    minQty = 1,
    stock = 0,
    maxOrderQty?: number | null
) => {
    const availableQuantities: Quantity[] = [];

    if (stock === 0 || minQty > stock) {
        return availableQuantities;
    }

    const qty = minQty < 1 ? 1 : minQty;

    // Use maxOrderQty if available, otherwise fall back to maxDisplayQty
    const effectiveMaxQty =
        maxOrderQty !== null && maxOrderQty !== undefined
            ? Math.min(MAX_DISPLAY_QTY, maxOrderQty)
            : MAX_DISPLAY_QTY;

    for (let i = qty; i <= stock && i <= effectiveMaxQty; i += qty) {
        availableQuantities.push({
            label: i.toString(),
            value: i.toString(),
        });
    }

    return availableQuantities;
};

const getDefaultSelectedInventory = (
    bopisDisabled: boolean,
    sddDisabled: boolean,
    isAutoshipSupported: boolean,
    isShipToHomeSupported: boolean
) => {
    if (bopisDisabled && isShipToHomeSupported) {
        return DeliveryType.STM;
    }
    if (bopisDisabled && !isShipToHomeSupported && isAutoshipSupported) {
        return DeliveryType.AUTOSHIP;
    }
    if (
        bopisDisabled &&
        !isShipToHomeSupported &&
        !isAutoshipSupported &&
        !sddDisabled
    ) {
        return DeliveryType.SDD;
    }

    return DeliveryType.BOPIS;
};

export { getAvailableQuantities, getDefaultSelectedInventory };
